import {
  PageBlueprint,
  createFrontendPlugin,
} from '@backstage/frontend-plugin-api';
import { ShieldCheck } from 'lucide-react';
import { PageShareTitle } from '../../lib/shareTitle';

export { approvalsListRouteRef, approvalDetailsRouteRef } from './routeRefs';
import { approvalsListRouteRef, approvalDetailsRouteRef } from './routeRefs';

const listPage = PageBlueprint.make({
  name: 'list',
  params: {
    path: '/approvals',
    title: 'Approvals',
    icon: <ShieldCheck size={20} strokeWidth={2} />,
    routeRef: approvalsListRouteRef,
    noHeader: true,
    loader: () =>
      import('./ApprovalsListPage').then(m => (
        <PageShareTitle title="Approvals">
          <m.ApprovalsListPage />
        </PageShareTitle>
      )),
  },
});

const detailsPage = PageBlueprint.make({
  name: 'details',
  params: {
    path: '/approvals/:id',
    routeRef: approvalDetailsRouteRef,
    noHeader: true,
    loader: () =>
      import('./ApprovalDetailsPage').then(m => <m.ApprovalDetailsPage />),
  },
});

export const approvalsPlugin = createFrontendPlugin({
  pluginId: 'approvals',
  extensions: [listPage, detailsPage],
  routes: {
    list: approvalsListRouteRef,
    details: approvalDetailsRouteRef,
  },
});
